import { useState } from 'react';

const LAT_LON_RE = /^\s*[+-]?\d{0,3}(?:\.\d{0,2})?\s*$/;

export default function useLocationForm() {
  const [lat, setLat] = useState('');
  const [lon, setLon] = useState('');
  const [city, setCity] = useState('');
  const [locationName, setLocationName] = useState('');
  const [method, setMethod] = useState(undefined);

  const changeNameField = (e) => setLocationName(e.target.value);
  const changeLatField = (e) => {
    if (LAT_LON_RE.test(e.target.value)) setLat(e.target.value);
  };
  const changeLonField = (e) => {
    if (LAT_LON_RE.test(e.target.value)) setLon(e.target.value);
  };

  const isLatLonMethod = method === 'latlon';
  const isPredefMethod = method === 'predef';
  const isShapeMethod = method === 'shape';

  return {
    method,
    setMethod,
    city,
    setCity,
    changeNameField,
    locationName,
    setLocationName,
    changeLatField,
    lat,
    setLat,
    changeLonField,
    lon,
    setLon,
    isLatLonMethod,
    isPredefMethod,
    isShapeMethod,
  };
}
